// date-helpers.ts

export function formatDate(
	dateStr: string | number | Date | null | undefined,
	options?: Intl.DateTimeFormatOptions,
) {
	if (dateStr == null) {
		return 'Undecided'
	}
	try {
		const date = new Date(dateStr)
		if (isNaN(date.getTime())) {
			return 'Undecided'
		}
		return date.toLocaleDateString('en-US', {
			timeZone: 'UTC',
			...options,
		})
	} catch {
		return 'Undecided'
	}
}

export const relativeDate = (date: Date, short: boolean): string => {
	const now = Date.now()
	const diffTime = now - date.getTime()
	const diffDays = Math.floor(diffTime / (1000 * 3600 * 24))
	const diffHours = Math.floor(diffTime / (1000 * 3600))

	if (diffDays >= 1) {
		return `${diffDays}${short ? 'd' : diffDays === 1 ? ' day' : ' days'} ago`
	}

	if (diffHours === 0) {
		return 'now'
	}

	return `${diffHours}${short ? 'h' : diffHours === 1 ? ' hour' : ' hours'} ago`
}

export function dateToISO(d: string | number | Date): string {
	try {
		const date = new Date(d)
		if (isNaN(date.getTime())) {
			return ''
		}
		return date.toISOString()
	} catch {
		console.error('dateToISO() failed', d)
		return ''
	}
}

export function timestamp(seconds: Date | number): Date {
	if (seconds instanceof Date) {
		return seconds
	}
	return new Date(seconds * 1000)
}

export function formatDateTime(
	dateStr: string | number | Date | null | undefined,
	options?: Intl.DateTimeFormatOptions,
): string {
	if (dateStr == null) {
		return 'N/A'
	}

	try {
		const date = new Date(dateStr)
		if (isNaN(date.getTime())) {
			return 'N/A'
		}
		return date.toLocaleString('en-US', {
			timeZone: 'UTC', // Force UTC timezone
			...(options ?? {}),
		})
	} catch (err) {
		console.error(err)
		return 'N/A'
	}
}
